
import { Model } from './model'
import { Compagnia } from  './compagnia'

export class ModelloCompagnia extends Model {
  static apiUrl: string = "cga_modelli_compagnie";

  compagnia: Compagnia;
  compagnia_id: number;

  nome_condizione: string;
  
  cod_modello: string;
  
  edizione: string;

  nome_file: File | string; 

  deserialize(input: any): ModelloCompagnia {
    let retV: ModelloCompagnia = new ModelloCompagnia();
    retV = super.deserialize(input) as ModelloCompagnia;
    
    if (input?.compagnia) {
      retV.compagnia = new Compagnia().deserialize(input.compagnia);
    }
    
    return retV;
  }

}
